/*
	Utility module to handle map resize
	across any desired instance of Google Maps
	* @param  {object} google    		Google Object
	* @param  {object} mapElement   DOM node for map container
 */

'use strict';

var debounce = require('../utilities/debounce');
var $ = require('jquery');

module.exports = function (google, mapElement) {
	//Redraw map after resize
	var resizeHandler = debounce(function () {
		if ($(window).outerWidth() > 768) {
			//Only trigger resize and redraw if map is visible
			//tabs module uses pos relative/absolute for visibility
			if ($('#map-view').css('position') === 'relative') {
				google.maps.event.trigger(mapElement, 'resize');
			}
		}
	}, 250);

	$(window).on('resize', resizeHandler).resize();
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/map-resize.js
// module id = 94
// module chunks = 0